"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { Box } from "../../core/Box/Box.mjs";
import VisuallyHidden_module_default from "./VisuallyHidden.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/VisuallyHidden/VisuallyHidden.tsx
const VisuallyHidden = factory((_props) => {
	const props = useProps("VisuallyHidden", null, _props);
	const { classNames, className, style, styles, unstyled, vars, attributes, ...others } = props;
	return /* @__PURE__ */ jsx(Box, {
		component: "span",
		...useStyles({
			name: "VisuallyHidden",
			classes: VisuallyHidden_module_default,
			props,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes
		})("root"),
		...others
	});
});
VisuallyHidden.classes = VisuallyHidden_module_default;
VisuallyHidden.displayName = "@mantine/core/VisuallyHidden";
//#endregion
export { VisuallyHidden };

//# sourceMappingURL=VisuallyHidden.mjs.map